import { useEffect, useState } from "react";
import { Box, Paper, Alert, Typography } from "@mui/material";

import Loading from "../../components/Loading";

const FILTER_FILES_PATH = "/files/filters";

const TabFilterDescription = ({screenerId}) => {

	const [content, setContent] 	= useState("");
	const [isLoading, setIsLoading]	= useState(false);
	const [error, setError] 		= useState(null);

	useEffect(() => {
		const controller = new AbortController();
		const numericId = Number(screenerId);


		if (isNaN(numericId)) {
			setContent("");
			setError(null);
			setIsLoading(false);
			return () => controller.abort();
		}

		const fetchDescription = async () => {
			setIsLoading(true);
			setError(null);
			setContent("");
			
			try {
				const manifestResponse = await fetch(`${FILTER_FILES_PATH}/index.json`, { signal: controller.signal });

				if (!manifestResponse.ok) {
					throw new Error("Manifesto de descrições não encontrado.");
				}

				const manifest = await manifestResponse.json();
				let fileName = manifest?.[String(numericId)];

				// Se nao achou o arquivo, tenta carregar o tutorial (id 0)
				if (!fileName) {
					fileName = 	'0-tutorial.html'
				}

				const htmlResponse = await fetch(`${FILTER_FILES_PATH}/${fileName}`, { signal: controller.signal });
				if (!htmlResponse.ok) {
					throw new Error("Arquivo de descrição não encontrado.");
				}

				const htmlContent = await htmlResponse.text();
				setContent(htmlContent);
			} catch (err) {
				if (controller.signal.aborted) return;
				setContent("");
				setError(err?.message || "Não foi possível carregar a descrição.");
			} finally {
				if (!controller.signal.aborted) {
					setIsLoading(false);
				}
			}
		};

		fetchDescription();

		return () => controller.abort();
	}, [screenerId]);

	if (isLoading) return (
		<Box display="flex" alignItems="center" justifyContent="center" py={2}><Loading/></Box>
	)

	return (
		<Paper
			className={`tab-filter-description`}
			elevation={0}
			sx={{
				p: { xs: 2, sm: 3 },
				minHeight: 80,
				bgcolor: "background.paper",
				display: "flex",
				justifyContent: "center"
			}}
			square
			>

			{error && (
				<Alert severity="error">Descrição indisponível: {error}</Alert>
			)}

			{!error && content && (
				<Box width="100%" display="flex" justifyContent="center">
					<Box
						className="tfd-content"
						sx={{
							width: "100%",
							maxWidth: 920,
							"& img": { maxWidth: "100%", height: "auto" },
							"& a": { color: "primary.main" },
							"& h1, & h2, & h3": { marginTop: 2, marginBottom: 1 },
							"& p, & li": { lineHeight: 1.7 },
						}}
						dangerouslySetInnerHTML={{ __html: content }}
					/>
				</Box>
			)}

			{!error && !content && (
				<Typography variant="body2" color="text.secondary">
					Nenhuma descrição disponível para este filtro.
				</Typography>
			)}
		</Paper>
	);
}

export default TabFilterDescription
